import { REVIEW_REQUESTS } from '../actions/types';

const INITIAL_STATE = {
	monthlyRequestTotals: [],
	numberOfReviewRequestsSentForGoal: 0,
	latestReviewRequests: [],
	loading: true,
};

export default function reviewRequestReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case REVIEW_REQUESTS:
			return { ...state, ...action.payload };
		default:
			return state;
	}
}
